<p-card [header]="title">
  <form (ngSubmit)="onSubmit()" [formGroup]="form" class="grid grid-cols-12" novalidate>
    <app-form-text-input [form]="form" [twoColumns]="true" id="names.De" label="GLOBAL.NAME_De"></app-form-text-input>

    <app-form-text-input [form]="form" [twoColumns]="true" id="names.Fr" label="GLOBAL.NAME_Fr"></app-form-text-input>

    <app-form-text-input [form]="form" [twoColumns]="true" id="names.It" label="GLOBAL.NAME_It"></app-form-text-input>

    <app-form-date-input
      [form]="form"
      [twoColumns]="true"
      id="validFrom"
      label="GLOBAL.GUELTIG_AB"></app-form-date-input>

    <app-form-date-input
      [form]="form"
      [twoColumns]="true"
      id="validTo"
      label="GLOBAL.GUELTIG_BIS"></app-form-date-input>

    <app-form-button-bar [form]="form" [saveDisabled]="submitting"></app-form-button-bar>
  </form>
</p-card>
